import { getItemMaker } from "./tools";

const i = getItemMaker("shoes");
export const shoes = [
  i("Flip Flops", "EquipmentShoes9"),
  i("Copper Boots", "EquipmentShoes1"),
  i("Goo Galoshes", "EquipmentShoes7"),
  i("Iron Boots", "EquipmentShoes15"),
  i("Cavern Trekkers", "EquipmentShoes16"),
  i("Logger Heels", "EquipmentShoes17"),
  i("Angler Boots", "EquipmentShoes18"),
  i("Bandito Boots", "EquipmentShoes19"),
  i("Gold Boots", "EquipmentShoes3"),
  i("Amarok Paws", "EquipmentShoes20"),
  i("Platinum Boots", "EquipmentShoes4"),
  i("Dementia Boots", "EquipmentShoes5"),
  i("Efaunts Broken Ankles", "EquipmentShoes21"),
  i("Void Imperium Kicks", "EquipmentShoes22"),
  i("Chizoar Walkers"),
  i("Cooking Clogs", "EquipmentShoes30"),
  i("Laboratory Scrubs", "EquipmentShoes32"),
  i("Spaggy Westerados", "EquipmentShoes29"),
  i("Lustre Shieldshoe"),
  i("Fiberous Footings"),
  i("Deep Sea Galoshes"),
  i("Rough Rockers"),
  i("Chef Hat Shoes"),
  i("Sheek Scrubs"),
  i("Diabolical Toe Tips"),
  i("Soles of the Troll", "EquipmentShoes34"),
  i("Divvy Slippers"),
  i("Magma Core Lavarunners"),
  i("Devious Slippers of the Divine"),
  i("Marbiglass Soles"),
  i("Drip of the Gods"),
];
